$(document).on("turbolinks:load", function () {
    $("#menu_item_name").on("keyup", function (e) {
        var name = $("#menu_item_name").val();
        $("#menu_item_printer_name").val(name);
        $("#menu_item_receipt_name").val(name);
    });
});